import { styled } from '@innowise-group/mui-kit';

export const FilesContainer = styled.div<{ column: number }>`
  margin-top: 1rem;
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  align-items: stretch;
  gap: 0.5rem 2rem;
  grid-auto-flow: column;
`;

export const InputContainer = styled.div<{
  disabled: boolean;
  status: 'default' | 'limit';
  columnStart: number;
}>`
  grid-column: ${({ columnStart }) => columnStart || 1} / -1;
  grid-row: ${({ columnStart }) => (!columnStart ? '1 / -1' : columnStart > 1 ? '1 / -1' : '6 / span 1')};
  flex: 1;
  min-height: 10rem;
  border: 1px dashed
    ${({ theme, disabled, status }) => {
      if (disabled) {
        return theme.palette.general.darkGrey[40];
      }
      if (status === 'default') {
        return theme.palette.info.pressed;
      }
      if (status === 'limit') {
        return theme.palette.general.darkGrey[60];
      }
    }};
  background-color: ${({ theme, status }) => {
    if (status === 'default') {
      return theme.palette.info.backgroundSecondary;
    }
    if (status === 'limit') {
      return theme.palette.general.lightGrey[20];
    }
  }};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  position: relative;
  transition: 0.2s;
  cursor: ${({ disabled }) => disabled && 'default'};

  & * {
    color: ${({ theme, disabled }) => disabled && `${theme.palette.general.darkGrey[60]} !important`};
    cursor: ${({ disabled }) => disabled && 'default !important'};
  }

  &:hover,
  &.dragover {
    background-color: ${({ theme, disabled, status }) => {
      if (status === 'limit') {
        return theme.palette.general.lightGrey[20];
      }
      if (disabled) {
        return 'transparent';
      }
      if (status === 'default') {
        return theme.palette.info.background;
      }
    }};
  }
`;

export const FileInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
`;

export const FileInputPlaceholder = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  white-space: pre-line;
`;

export const FileInputBlockDefault = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
  color: ${({ theme }) => theme.palette.general.darkGrey[80]};
  ${({ theme }) => theme.fonts.primary[60]};
`;

export const DefaultTitle = styled.span`
  ${({ theme }) => theme.fonts.primary[80]};
  color: ${({ theme }) => theme.palette.info.default};
`;

export const DefaultHightLighted = styled.span`
  color: ${({ theme }) => theme.palette.info.default};
`;

export const FileInputBlockLimit = styled(FileInputBlockDefault)`
  text-align: start;
  color: ${({ theme }) => theme.palette.general.darkGrey[80]};
`;

export const LimitTitle = styled.span`
  ${({ theme }) => theme.fonts.primary[80]};
`;

export const LimitDescriptionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  ${({ theme }) => theme.fonts.primary[60]};
`;

export const LimitDescriptionText = styled.span`
  ${({ theme }) => theme.fonts.primary[20]};
`;
